import { render, staticRenderFns } from "./AppointmentDetail.vue?vue&type=template&id=4a39b8d4&scoped=true"
import script from "./AppointmentDetail.vue?vue&type=script&lang=js"
export * from "./AppointmentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a39b8d4",
  null
  
)

export default component.exports